import { render, staticRenderFns } from "./labEditForm.vue?vue&type=template&id=70de563b&scoped=true&"
import script from "./labEditForm.vue?vue&type=script&lang=js&"
export * from "./labEditForm.vue?vue&type=script&lang=js&"
import style0 from "./labEditForm.vue?vue&type=style&index=0&id=70de563b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de563b",
  null
  
)

export default component.exports